function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserMaleAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "user_x5F_male_x5F_add",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "user_x5F_male_x5F_add_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD5C3F"
    },
    d: "M24,32c-4.411,0-8-3.589-8-8s3.589-8,8-8s8,3.589,8,8S28.411,32,24,32z M24,18 c-3.309,0-6,2.692-6,6s2.691,6,6,6s6-2.692,6-6S27.309,18,24,18z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 23,
    style: {
      fill: "#FD5C3F"
    },
    width: 6,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 21,
    style: {
      fill: "#FD5C3F"
    },
    width: 2,
    height: 6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD5C3F"
    },
    d: "M16,32H0v-1c0-3.194,3.446-4.617,6.487-5.874C8.706,24.209,11,23.261,11,22 c0-0.59-0.375-1.176-0.893-1.987C9.473,19.021,8.703,17.815,8.21,16H8c-1.554,0-2.367-2.073-2.367-4.122 c0-1.574,0.508-2.736,1.354-3.234C7.176,3.846,11.146,0,16,0c4.854,0,8.824,3.846,9.012,8.645 c0.278,0.162,0.522,0.394,0.722,0.689c0.856,1.269,0.761,3.604,0.182,5.04l-1.854-0.748c0.514-1.276,0.285-3.058-0.055-3.252 h-1.048l0.051-1.2C23.014,9.116,23.019,9.059,23.019,9c0-3.86-3.149-7-7.019-7S8.981,5.14,8.981,9 c0,0.059,0.005,0.116,0.009,0.174l0.058,1.202H8c-0.061,0.029-0.293,0.329-0.354,1.135C7.561,12.653,7.894,13.716,8.129,14h1.688 l0.164,0.8c0.39,1.91,1.146,3.093,1.813,4.136C12.414,19.908,13,20.826,13,22c0,2.599-2.923,3.807-5.75,4.975 C5.17,27.834,3.032,28.718,2.281,30H16V32z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserMaleAdd);
export default __webpack_public_path__ + "static/media/user_male_add.71ea42fc12ea4c8fa9b93f267313f02f.svg";
export { ForwardRef as ReactComponent };